import { useWishLists } from '@/data/Content/WishLists';
import { useEffect, useState } from 'react';

export const useIsInWishList = (productId?: string) => {
	const [isInWishList, setIsInWishList] = useState<boolean>(false);
	const {favoritesWishList, mutateWishLists, isLoading} = useWishLists();

	const checkIsInWishList = async () => {
		await mutateWishLists();
	};

	useEffect(() => {
		const found = favoritesWishList?.item?.find(
			(item) => item.productId === productId
		);
		setIsInWishList(!!found);
	}, [favoritesWishList, productId]);

	return {
		isLoading,
		isInWishList,
		checkIsInWishList,
	};
};
